module.exports = __webpack_public_path__ + "static/media/c64.63a13484.gif";